module.exports = require("./hu-HU.js");